import React from 'react';

import { CSSInterpolation } from '@emotion/css/create-instance';
import { CssVars, NeutralColorToken, SemanticColorToken } from '@robinhood/design';
import { Button as RHDesignButton } from '@robinhood/design';
import { Props } from '@robinhood/design/product/components/Button';

type Variant = 'primary' | 'secondary';

const Button = ({ variant = 'primary', ...props }: Props & { variant?: Variant }) => {
  const foregroundColor =
    props.state === 'disabled'
      ? NeutralColorToken.Fg3
      : variant === 'secondary'
        ? NeutralColorToken.Fg1
        : SemanticColorToken.Positive;
  const overrideButtonStyles = React.useMemo<CSSInterpolation>(() => {
    const isClickable = props.state !== 'disabled' && props.state !== 'loading';
    return [
      {
        backgroundColor: CssVars.neutral.bg2,
        height: '56px',
        borderRadius: '56px',
        border: `solid ${CssVars.neutral.bg3} 1px`,
      },
      isClickable && {
        '&:hover': {
          backgroundColor: CssVars.neutral.bg3,
        },
      },
      isClickable && {
        '&:active': {
          backgroundColor: CssVars.neutral.bg3,
        },
      },
    ];
  }, [props.state]);

  return (
    <RHDesignButton
      foregroundColor={foregroundColor}
      {...props}
      overrideButtonStyles={[overrideButtonStyles, props.overrideButtonStyles]}
    />
  );
};

export default Button;
